import React, { useState } from "react";
import { Collapse, Table, Button, Select, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import ServiceManagement from "./ServiceManagement";
import AppointmentManager from "./AppointmentManager";

const { Panel } = Collapse;
const { Option } = Select;

const DiagnosticImagingCenter = () => {
  return (
    <div className="diagnostic-imaging-center">
      <div style={{ margin: "20px" }}>
        <Collapse accordion>
          <Panel header="Service Management" key="1">
            <ServiceManagement />
          </Panel>
          <Panel header="Appointment Management" key="2">
            <AppointmentManager />
          </Panel>
        </Collapse>
      </div>
    </div>
  );
};

export default DiagnosticImagingCenter;
